import React from 'react';
import KPI from './KPI';

const DashboardTab = () => (
  <div className="space-y-6 p-6">
    <h1 className="text-2xl font-bold text-gray-800">Reliant Billing</h1>
    <div className="bg-white rounded shadow overflow-hidden">
      <iframe
        title="QuickSight Dashboard"
        className="w-full h-[600px]"
        src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/991028191336/dashboards/ac1a7e15-62d5-4e7c-9ec4-d26d9537aa47?directory_alias=yaqeentechdemo"
        frameBorder="0"
      ></iframe>
    </div>
  </div>
);

export default DashboardTab;

